import { observer } from "mobx-react";

//components
import withLocalization from "../../hoc/withLocalization";

//utils
import { shortDateFormat } from "../../utils/dateFormat";

// The employer / outside-employer breakdown for a 'doctor' absence in the approval modal: shown as a
// preview of what the payroll sync will send, and afterwards as what it actually sent. Same card
// either way - the result adds a status column, which is what `showStatus` switches on.
const MedicalLeaveSyncTable = ({ parts, title, showStatus, isActivityBased, defaultHolidaysExcluded, dateTimeRules, t }) => {
    if (!parts || !parts.length) return null;

    const columns = showStatus
        ? [
            { label: t('Payer'), width: '25%' },
            { label: t('Dates'), width: '28%' },
            { label: isActivityBased ? t('Activity') : t('Wage Type'), width: '32%' },
            { label: t('Status'), width: '15%' },
        ]
        : [
            { label: t('Payer'), width: '30%' },
            { label: t('Dates'), width: '40%' },
            { label: isActivityBased ? t('Activity') : t('Wage Type'), width: '30%' },
        ];

    // Not a plain success/failed binary - a Visma row can be legitimately 'pending' between
    // submitting and the async job poll resolving it.
    const getStatusConfig = (status) => {
        if (status === 'success') return { icon: '✓', text: t('Success'), className: 'text-success' };
        if (status === 'pending') return { icon: <i className="fa fa-clock-o" />, text: t('Pending'), className: 'text-warning' };
        return { icon: '✗', text: t('Failed'), className: 'text-danger' };
    };

    return (
        <div className="timelog-array__right w-100 mt-2 mb-2">
            <div className="border rounded" style={{ backgroundColor: '#fafafa' }}>
                <div className="d-flex align-items-center justify-content-between px-2 py-1 border-bottom bg-white">
                    <span className="fw-semibold text-dark" style={{ fontSize: '12px' }}>
                        {title}
                    </span>
                    {defaultHolidaysExcluded && (
                        <span className="text-danger" style={{ fontSize: '10px' }}>
                            {t('Default holidays are not included')}
                        </span>
                    )}
                </div>
                <div className="px-2 py-1">
                    {/* Header and rows are two separate tables so the header stays put while the rows scroll. */}
                    <table className="table table-sm mb-0" style={{ tableLayout: 'fixed' }}>
                        <thead>
                            <tr style={{ fontSize: '10px' }}>
                                {columns.map(column => (
                                    <th
                                        key={column.label}
                                        className="border-0 text-muted fw-normal"
                                        style={{ width: column.width, padding: '2px 4px', lineHeight: 1.2, textAlign: 'left' }}
                                    >
                                        {column.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                    </table>
                    <div style={{ maxHeight: '165px', overflowY: 'auto' }}>
                        <table className="table table-sm mb-0" style={{ tableLayout: 'fixed' }}>
                            <tbody>
                                {parts.map((part, index) => {
                                    const statusConfig = showStatus ? getStatusConfig(part.status) : null;
                                    return (
                                        <tr key={index} style={{ fontSize: '11px' }}>
                                            <td className="py-1" style={{ width: columns[0].width, textAlign: 'left' }}>
                                                {part.payer === 'government' ? t('Outside Employer Period') : t('Employer Period')}
                                            </td>
                                            <td className="py-1" style={{ width: columns[1].width, textAlign: 'left' }}>
                                                {shortDateFormat(part.from, dateTimeRules)} | {shortDateFormat(part.to, dateTimeRules)}
                                            </td>
                                            <td className="py-1" style={{ width: columns[2].width, textAlign: 'left', paddingRight: '16px' }}>
                                                {part.wagetypeLabel || <span className="text-danger">{t('Not configured')}</span>}
                                            </td>
                                            {statusConfig && (
                                                <td className={`py-1 ${statusConfig.className}`} style={{ width: columns[3].width, textAlign: 'left', whiteSpace: 'nowrap' }}>
                                                    <div className="d-flex align-items-center" style={{ whiteSpace: 'nowrap' }}>
                                                        <span className="me-1">{statusConfig.icon}</span>{statusConfig.text}
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withLocalization(observer(MedicalLeaveSyncTable));
